module.exports = __webpack_public_path__ + "img/Card balance.d89bd307.svg";